import { LOADED,ADDBOOK,UPDATEBOOK,DELETEBOOK } from "./actionTypes";
import initialState from "./initialState";

const nextBookId = (books)=>{
    const maxID = books.reduce((maxId, books) => Math.max(books.id, maxId), -1);
    return maxID + 1;
}

const reducer = (state = initialState, action)=> {
    switch (action.type) {
        case LOADED:
            return action.payload;
        case ADDBOOK:
            const {name, author, thumbnail, price, rating, featured} = action.payload;
            return[
                ...state,
                {
                    id: nextBookId(state),
                    name,
                    author,
                    thumbnail,
                    price: parseFloat(price),
                    rating : parseInt(rating),
                    featured,
                },
            ];
        case UPDATEBOOK:
            return state.map(book => book.id === action.id ? action.payload : {...book});
        case DELETEBOOK:
            return state.filter(value => value.id !== action.payload);           
        default:
            return state;          
    }
}

export default reducer;